import logo from './logo.svg';
import './App.scss';
import MainContent from "./components/MainContent";

function App() {
  return (
    <div className="App">
      <MainContent/>
    </div>
  );
}

export default App;
